import type {AppError, ResultWithOauthToken} from '@packages/utils';
import type {InfiniteData} from '@tanstack/react-query';
import type {UsersMeClipsResponse} from '../../entities/clip/schema';

/**
 * 与えられたInfiniteDataからクリップの配列を返します。成功していない結果とnullのクリップはフィルタリングされます。
 * @param isFetching - データ取得中かどうかを示します。
 * @param data - クリップを含むInfiniteDataオブジェクトです。
 * @returns クリップの配列を返します。
 */
export function getClipsFromPages(
  isFetching: boolean,
  data:
    | InfiniteData<ResultWithOauthToken<UsersMeClipsResponse, AppError>>
    | undefined,
) {
  if (isFetching || !data?.pages) return [];

  return (
    data.pages
      // 成功していない結果をフィルタリング
      .filter(
        (
          result,
        ): result is ResultWithOauthToken<UsersMeClipsResponse, AppError> & {
          ok: true;
        } => result.ok,
      )
      // 各Resultからvalueを抽出
      .map((v) => v.value)
      // クリップ配列をフラット化
      .flatMap((v) => v.clips)
      // Nullのクリップをフィルタリング
      .filter((clip) => clip !== null && clip !== undefined)
  );
}
